import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 110, damping: 30, mass: 0.4 });
  return (
    <motion.div
      data-testid="scroll-progress"
      style={{ scaleX, transformOrigin: "0% 50%" }}
      className="fixed top-0 left-0 right-0 h-1.5 z-[60] origin-left"
    >
      <div className="h-full w-full bg-gradient-to-r from-[#c92e34] via-[#c92e34] to-[#282829]" />
    </motion.div>
  );
}
